var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalRevenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.808,
    height: 30.928,
    viewBox: "0 0 34.808 30.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_revenue_",
    "data-name": "Total revenue ",
    transform: "translate(-182.779 -204.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M275.612,253.021a1.459,1.459,0,1,1,1.621-1.45.853.853,0,1,0,1.706,0,3.181,3.181,0,0,0-2.474-3.029v-1.45a.853.853,0,0,0-1.706,0v1.45a3.181,3.181,0,0,0-2.474,3.029,3.244,3.244,0,0,0,3.327,3.157,1.459,1.459,0,1,1-1.621,1.45.853.853,0,0,0-1.706,0,3.181,3.181,0,0,0,2.474,3.029v1.45a.853.853,0,0,0,1.706,0v-1.45a3.131,3.131,0,0,0-.853-6.186Z",
    transform: "translate(-81.444 -38.357)",
    fill: "#ff790d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M238.71,332.91h-7.38a.853.853,0,1,0,0,1.706h5.247l-7.209,7.209-5.972-6.014a.825.825,0,0,0-1.195,0l-15.015,14.973a.825.825,0,0,0,0,1.195.825.825,0,0,0,1.194,0l14.376-14.332,6.014,5.972a.825.825,0,0,0,1.194,0l7.892-7.892v5.46a.853.853,0,1,0,1.706,0v-7.422a.856.856,0,0,0-.853-.853Z",
    transform: "translate(-21.976 -117.222)",
    fill: "#ff790d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M191.523,226.651l1.45-1.45a9.721,9.721,0,1,1,10.921-9.684,9.879,9.879,0,0,1-.9,4.052l1.28,1.28a11.219,11.219,0,0,0,1.322-5.332,11.411,11.411,0,1,0-14.077,11.134Z",
    transform: "translate(0 0)",
    fill: "#ff790d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M323.542,400.63a9.845,9.845,0,0,1-4.65,3.029l-2.09,2.09a11.317,11.317,0,0,0,7.934-3.924Z",
    transform: "translate(-121.951 -178.843)",
    fill: "#ff790d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRevenue);
export default __webpack_public_path__ + "static/media/TotalRevenue.d297b360c3279b91959b4cd69ddd4d07.svg";
export { ForwardRef as ReactComponent };